module.exports = __webpack_public_path__ + "img/sender.925e1a1e.png";